import { PaymentMethodsResponse } from '@adyen/adyen-web/auto'
import { useContext, useEffect, useState } from 'react'

import bugsnagClient from '@/lib/bugsnag'
import logger from '@/lib/logger'
import isNetworkError from '@/utils/isNetworkError'
import StoresContext from '@/utils/StoresContext'

export default function useAdyenPaymentMethods(amount: number): PaymentMethodsResponse | null {
  const { appStore } = useContext(StoresContext)
  const [adyenPaymentMethods, setAdyenPaymentMethods] = useState<PaymentMethodsResponse | null>(null)

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await appStore.getAdyenPaymentMethods(amount)
        setAdyenPaymentMethods(response)
      } catch (error) {
        if (!isNetworkError(error)) {
          logger.error(error)
          bugsnagClient.notify(error)
        }
      }
    }

    fetchPaymentMethods()
  }, [appStore, amount])

  return adyenPaymentMethods
}
